export default "__VITE_ASSET__c640a20b__"